import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

/**
 * Only allows the component to be displayed if the user is authenticated and belongs to one of the provided groups.
 * This means that unauthenticated users, or authenticated users who do not belong to the group will NOT be
 * allowed to see the contents.
 * @param Component component to be wrapped in route validation.
 * @param allowedGroups list of groups allowed to view the route.
 * @returns {(function(*): (*|null))|*} Component if the user is authenticated and belongs to one of the allowed groups,
 * otherwise a redirect to '/'.
 */
export default function GroupBasedAuthenticator(Component, allowedGroups = []) {
  return function wrapper(props) {
    const { groups } = useAuth();

    const isAllowed = groups.map((g) => allowedGroups.includes(g)).some((v) => !!v);

    if (isAllowed) {
      return <Component {...props} />;
    }

    return <Navigate to="/" replace />;
  };
}
